module.exports = __webpack_public_path__ + "img/quick-summer-drink-460x295.49f12c41.jpg";